import React, { FC } from 'react'
import styled from 'styled-components'
import RoundButton from 'uiComponents/atoms/Buttons/RoundButton'
import Icon, { IconSize } from 'uiComponents/atoms/Icon/Icon'
import { IconName } from 'uiComponents/atoms/Icon/IconName'

export const DropDetailsBackButtonLink: FC<{
  to: string
  onClick: () => void
}> = ({ to, onClick }) => {
  return (
    <StyledLink data-testid="BackButton" href={to} onClick={onClick}>
      <RoundButton backgroundColor={'secondary'} data-testid="RoundBackButton">
        <StyledIcon
          size={IconSize.XS}
          asset={IconName.IcChevronLeft}
          data-testid="BackButtonArrow"
        />
      </RoundButton>
    </StyledLink>
  )
}

const StyledLink = styled.a`
  position: absolute;
  top: 30px;
  left: 60px;
  z-index: 1;
`

const StyledIcon = styled(Icon)`
  margin-right: 4px;
`
